module.exports = __webpack_public_path__ + "img/winerackdog49.765bddf6.jpg";